import React, { useEffect } from 'react'
import PostLogin from '../../layout/postLogin'
import { NAME_NEW_AGGREGATION } from '../../constants'
import Add from './add'
import { Wrapper } from './style'

const NewAggregation = () => {
  useEffect(() => {
    document.title = NAME_NEW_AGGREGATION
  }, [])

  return (
    <PostLogin pageTitle={NAME_NEW_AGGREGATION}>
      <Wrapper>
        <Add />
      </Wrapper>
    </PostLogin>
  )
}

export default NewAggregation
